import Swiper from "swiper";

const pageSliderThumbs = new Swiper(".js-about-shop-swiper-thumbs", {
    spaceBetween: 6,
    slidesPerView: 6,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    watchOverflow: true,
});

new Swiper(".js-about-shop-slider-init", {
    navigation: {
        nextEl: ".js-about-shop-thumb-next",
        prevEl: ".js-about-shop-thumb-prev",
    },
    pagination: {
        el: ".js-about-shop-swiper-pagination",
        clickable: true,
    },
    thumbs: {
        swiper: window.mobileMedia ? null : pageSliderThumbs,
        slideThumbActiveClass: "active",
    },
});
